/** @format */

import { Button, Chip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
	buttonColors,
	colors,
	typographyHeaderColor,
} from "../../utility/types/constant";

export const Container = styled("div")(({ theme }) => ({
	padding: "80px 20px",
	backgroundColor: "#f8f9fa",
	position: "relative",
	overflow: "hidden",
	"&::before": {
		content: '""',
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		height: "4px",
		background: colors.mainSecondary,
	},
}));

export const HeaderDiv = styled("div")(({ theme }) => ({
	textAlign: "center",
	marginBottom: "60px",
	paddingTop: "20px",
}));

export const SubHeaderDiv = styled("div")(({ theme }) => ({
	// backgroundColor: 'red',
	display: "grid",
	gridTemplateRows: "1fr",
	gridColumn: "1 / -1", // Spans all columns
	justifyContent: "center",
	alignItems: "center",
	height: "10vh",
	textAlign: "center",
	[theme.breakpoints.down("sm")]: {
		gridColumn: "1 / -1", // Spans all columns
	},
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(2rem, 4vw, 3rem)",
	fontWeight: 800,
	color: colors.primary,
	textAlign: "center",
	marginBottom: "10px",
	letterSpacing: "-0.02em",
}));

export const SectionSubtitle = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(1rem, 2vw, 1.25rem)",
	fontWeight: 400,
	color: "#6c757d",
	textAlign: "center",
	maxWidth: "700px",
	margin: "0 auto",
	lineHeight: 1.7,
}));

// Modern Card Components
export const ModernCard = styled("div")(({ theme }) => ({
	backgroundColor: "#ffffff",
	borderRadius: "16px",
	padding: "30px",
	boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
	transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
	border: "1px solid rgba(0,0,0,0.05)",
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	height: "100%",
	"&:hover": {
		transform: "translateY(-8px)",
		boxShadow: "0 12px 24px rgba(30, 193, 149, 0.15)",
		borderColor: colors.mainSecondary,
	},
}));

export const IconWrapper = styled("div")(({ theme }) => ({
	width: "60px",
	height: "60px",
	borderRadius: "12px",
	background: colors.mainSecondary,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	marginBottom: "20px",
	color: "#ffffff",
	fontSize: "30px",
	transition: "all 0.3s ease",
	"& svg": {
		fontSize: "30px",
	},
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "1.25rem",
	fontWeight: 700,
	color: "#2d3748",
	marginBottom: "12px",
	lineHeight: 1.3,
}));

export const CardDescription = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "0.9375rem",
	fontWeight: 400,
	color: "#6c757d",
	lineHeight: 1.7,
}));

export const ChildTypography = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "19.58px",
	fontWeight: 400,
	color: typographyHeaderColor.primary,
	textAlign: "center",
}));

export const TextAreaTypography = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "17.58px",
	fontWeight: 400,
	color: typographyHeaderColor.white,
	textAlign: "center",
}));

// ── Demo CTA section ──────────────────────────────────────────────────────
export const DemoButtonWrapper = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	gap: "16px",
	paddingTop: "16px",
	paddingBottom: "16px",
}));

export const TryDemoButton = styled(Button)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontWeight: 700,
	fontSize: "1rem",
	padding: "14px 40px",
	borderRadius: "50px",
	backgroundColor: colors.primary,
	color: "#ffffff",
	textTransform: "none",
	boxShadow: "0 4px 20px rgba(4,13,69,0.25)",
	transition: "all 0.2s ease",
	"&:hover": {
		backgroundColor: "#143AA2",
		boxShadow: "0 6px 28px rgba(4,13,69,0.35)",
		transform: "translateY(-2px)",
	},
}));

export const DemoBadge = styled(Chip)(({ theme }) => ({
	backgroundColor: "rgba(30, 193, 149, 0.1)",
	color: colors.mainSecondary,
	border: `1px solid rgba(30, 193, 149, 0.3)`,
	fontFamily: "'Montserrat', sans-serif",
	fontWeight: 600,
	fontSize: "0.75rem",
}));

export const LearnMoreButtonDiv = styled("div")(({ theme }) => ({
	display: "grid",
	gridTemplateRows: "1fr",
	gridColumn: "1 / -1",
	justifyContent: "center",
	alignItems: "center",
	height: "10vh",
	marginTop: 25,

	[theme.breakpoints.down("sm")]: {
		gridColumn: "1 / -1",
	},
}));

export const LearnMoreButton = styled(Button)(({ theme }) => ({
	paddingTop: "5px",
	paddingBottom: "5px",
	border: "none",
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "20px",
	fontWeight: 400,
	backgroundColor: buttonColors.primary,

	cursor: "pointer",
	color: "#FFFFFF",
	width: "390px",
	"&:hover": {
		backgroundColor: buttonColors.primary,
	},
	textTransform: "none",
	maxWidth: "200px",
}));
